import React from 'react';
import { cn } from '@/utils/cn';

export interface TutaraCheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  onCheckedChange?: (checked: boolean) => void;
}

export const TutaraCheckbox = React.forwardRef<HTMLInputElement, TutaraCheckboxProps>(
  ({ className, label, onCheckedChange, onChange, ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      // Call onCheckedChange if provided (controlled component pattern)
      if (onCheckedChange) {
        onCheckedChange(e.target.checked);
      }
      // Also call onChange for backwards compatibility
      if (onChange) {
        onChange(e);
      }
    };

    return (
      <label className="flex items-center gap-2 cursor-pointer">
        <input
          ref={ref}
          type="checkbox"
          className={cn(
            'w-4 h-4 rounded border-2 transition-all',
            'border-gray-300 dark:border-gray-600',
            'text-tutara-turquoise',
            'focus-visible:ring-2 focus-visible:ring-tutara-turquoise focus-visible:ring-offset-2',
            'disabled:cursor-not-allowed disabled:opacity-50',
            className
          )}
          onChange={handleChange}
          {...props}
        />
        {label && (
          <span className={cn(
            'text-sm text-tutara-charcoal dark:text-gray-200',
            props.disabled && 'text-tutara-gray'
          )}>
            {label}
          </span>
        )}
      </label>
    );
  }
);

TutaraCheckbox.displayName = 'TutaraCheckbox';
